import { useLocation } from 'wouter'
import FondPage from './FondPage'
import HubHeader from './HubHeader'
import { BarreHubClient, BarreHubProducteur } from './BarreOnglets'
import { useCasquette } from '../contexts/casquette'
import { useNavigationPortail, useActionsPortail } from '../contexts/navigation'
import { MVP } from '../mvp'

// Libelle du bouton retour quand `retour` est une cle d'onglet.
const LIBELLES = { home: 'Accueil', explore: 'Explorer', account: 'Compte', wallet: 'Wallet' }

/**
 * Layout d'une page du hub (S50) : fond, header (avec bouton retour SIMPLE),
 * barre basse. Les parametres de navigation sont DECLARES par l'appelant :
 *  - `retour` : cle d'onglet ('account', 'explore'...) → « ← Compte » qui
 *    navigue vers l'onglet ; { label, vers } → navigue vers ce CHEMIN (sous-
 *    pages en Route, ex. /account/securite/pin → retour vers /account/securite) ;
 *    { label, onClick } pour une sous-navigation locale ; null = pas de retour.
 *  - `barre` : le COMPOSANT de barre basse — defaut : la barre du hub de la
 *    casquette active (BarreHubClient / BarreHubProducteur) ; passer un autre
 *    composant pour une barre specifique, ou `false` pour aucune. Masquee de
 *    toute facon sous l'immersif et la page RINA.
 * Remplace le calcul centralise du backChip (tables ONGLET_PARENT/
 * ACCOUNT_PARENTS de l'ex-HubShell) : chaque page porte sa navigation.
 */
export default function PageHub({ retour = null, barre, children }) {
  const etat = useNavigationPortail()
  const actions = useActionsPortail()
  const { hubMode, isProducer } = useCasquette()
  // MVP (S62) : un client simple n'a pas de barre basse (MVP.BARRE_CLIENT) —
  // il navigue par le hero de l'accueil et le bouton reglages du header.
  const barreParDefaut = hubMode === 'producer'
    ? <BarreHubProducteur />
    : (isProducer || MVP.BARRE_CLIENT) ? <BarreHubClient /> : null

  const [, setLocation] = useLocation()
  const chip = !retour
    ? null
    : typeof retour === 'string'
      ? { label: LIBELLES[retour] ?? retour, onClick: () => actions.setHubTab(retour) }
      : retour.vers
        ? { label: retour.label, onClick: () => setLocation(retour.vers) }
        : retour

  return (
    <FondPage halos>
      <div className="pb-28 max-w-md mx-auto relative z-[2]">
        <HubHeader backChip={chip} />
        <div className="px-4 pt-3">
          {children}
        </div>
      </div>

      {/* FAB RINA RETIRE (arbitrage Enzo, S31) : tant que RINA ne peut pas
          AGIR, pas de lanceur permanent — reglage « Bientot » dans Parametres.
          Pour le remettre : reintroduire <RinaFab /> ici. */}
      {barre !== false && !etat.showImmersive && !etat.showRinaChat && (barre ?? barreParDefaut)}
    </FondPage>
  )
}
